import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../helper/core/core.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public displayFooter:boolean;

  constructor(
    private coreService:CoreService
  ) { }

  ngOnInit() {
    this.displayFooter = this.coreService.inIframe();
    if(this.displayFooter){
      $('html').addClass('in-iframe');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts